import React from 'react';
import { education } from '../data';

export default function Education() {
  return (
    <section id="education" style={{
      padding: '6rem 2.5rem',
      maxWidth: '900px', margin: '0 auto',
      fontFamily: "'DM Mono', monospace",
    }}>
      <div style={{
        fontSize: '10px', letterSpacing: '0.22em',
        textTransform: 'uppercase', color: '#9b9991',
        marginBottom: '3rem',
        display: 'flex', alignItems: 'center', gap: '1rem',
      }}>
        Education
        <span style={{ flex: 1, height: '0.5px', background: 'rgba(100,98,92,0.15)', maxWidth: '60px' }} />
      </div>

      <div>
        {education.map((item, i) => (
          <div key={i} style={{
            display: 'grid',
            gridTemplateColumns: '100px 1fr',
            gap: '2rem',
            padding: '2rem 0',
            borderTop: i === 0 ? '0.5px solid rgba(100,98,92,0.15)' : 'none',
            borderBottom: '0.5px solid rgba(100,98,92,0.15)',
            alignItems: 'start',
          }}>
            <span style={{
              fontSize: '11px', letterSpacing: '0.1em',
              color: '#9b9991', paddingTop: '2px',
            }}>
              {item.years}
            </span>

            <div>
              <div style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: '20px', fontWeight: 300,
                color: '#2e2d2a', lineHeight: 1.3, marginBottom: '4px',
              }}>
                {item.degree}
              </div>
              <div style={{
                fontSize: '12px', letterSpacing: '0.08em',
                color: '#3d6e78', marginBottom: '8px',
              }}>
                {item.school}
              </div>
              {item.note && (
                <div style={{ fontSize: '12px', color: '#9b9991', lineHeight: 1.6 }}>
                  {item.note}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
